import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import { set } from 'lodash';

const InputSemanaEjecucion = (p) => {
    const [semana, setSemana] = useState(p.data.semana_ejecucion ?? p.data.semana_siembra);
    const [border, setborder] = useState('border-2');
    const evaluando = "scale-continue-05 border border-2 border-warning";
    const noValido = " border border-2 border-danger";
    const actualizado = " border border-2 border-success text-bold";
    const normal = "border-2";
    useEffect(() => {
        setSemana((p.data ?? {}).semana_ejecucion ?? p.data.semanainicio)
    }, [p.data]);

    const change = (e) => {
        let { value } = e.target;
        setSemana(value);
        if (value === "" || semanaValida(value)) update(value);
        else setborder(noValido);
    }

    const semanaValida = (val) => {
        if (val.length !== 4) return false;
        try {
            let anio = parseInt(val.substring(0, 2));
            let sem = parseInt(val.substring(2, 4));
            if (anio < 21 || anio > 50) return false;
            if (sem < 1 || sem > 52) return false;
        } catch (error) {
            return false;
        }
        return true;
    }

    const update = async (value = semana) => {
        setborder(evaluando);
        let dataSend = { semana: value, id: p.data.id };
        let resp = await Post('/api/vivero/plan/actualizarSemanaEjecucion', dataSend);
        if (!resp) return setborder(noValido);
        actualizadoCompleto(resp.data);
    }

    const actualizadoCompleto = (nuevosDatos) => {
        setborder(actualizado);
        if (p.update) p.update(nuevosDatos)
        setTimeout(() => {
            setborder(normal)
        }, 500);
    }

    const diferencia = () => {
        if (p.data.semana_ejecucion && p.data.fecha_inicio) {
            let inicio = new Date(p.data.fecha_inicio);
            let ejecucion = new Date(p.data.fecha_semana_ejecucion);

            let diferencia = ejecucion - inicio;
            let dias = diferencia / (1000 * 60 * 60 * 24);
            let semanas = dias / 7;
            return Math.floor(semanas);
        }
        return 0;
    }

    return (
        <div className='' style={{ width: "110px" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0 '>
                <input type='number' className={`form-control form-control-sm text-center ${diferencia() != 0 ? "w-70" : "w-100"}  ${border}`} value={semana} name='semana_ejecucion' onChange={change} />
                {diferencia() != 0 && <div className='w-30 contenedor '>{diferencia()}</div>}
            </div>
        </div>
    )
}

export default InputSemanaEjecucion;